import { productApiClient } from '@/clients/ProductAPIClient';
import { IAlbum } from '@/data/models/album';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetAlbumsQuery(
  ids: Array<string | number>
): UseQueryResult<IAlbum[], Error> {
  async function queryFn() {
    if (!ids?.length) return [];
    const response = await productApiClient.getAlbums(ids);
    return response.data;
  }

  return useQuery({
    queryFn,
    queryKey: ['albums', ids.sort()],
    staleTime: 10000,
  });
}
